import {
	organizationConstructionMaterialPriceChangeConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	error         : null,
	isSending     : false,
	paged         : {},
	changed       : null,
	organizations : []
}

export default function (state = initialState, action){
	switch (action.type){
		case (organizationConstructionMaterialPriceChangeConstants.GetPaged.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.Create.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.Delete.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.GetLastPricePaged.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.GetByFile.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.GetExampleFile.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.Update.REQUEST):
		case (organizationConstructionMaterialPriceChangeConstants.GetPricesFile.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (organizationConstructionMaterialPriceChangeConstants.GetPaged.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.Create.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.Delete.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.GetLastPricePaged.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.GetByFile.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.GetExampleFile.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.Update.FAILURE):
		case (organizationConstructionMaterialPriceChangeConstants.GetPricesFile.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (organizationConstructionMaterialPriceChangeConstants.Create.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case (organizationConstructionMaterialPriceChangeConstants.Update.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (organizationConstructionMaterialPriceChangeConstants.Delete.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case (organizationConstructionMaterialPriceChangeConstants.GetPaged.SUCCESS):
		case (organizationConstructionMaterialPriceChangeConstants.GetLastPricePaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (organizationConstructionMaterialPriceChangeConstants.GetExampleFile.SUCCESS):
		case (organizationConstructionMaterialPriceChangeConstants.GetPricesFile.SUCCESS):
			return {
				...state,
				isSending: false
			}
		case (organizationConstructionMaterialPriceChangeConstants.GetByFile.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : actions.download
			}
		case (organizationConstructionMaterialPriceChangeConstants.GetOrganizations.SUCCESS):
			return {
				...state,
				isSending     : false,
				organizations : action.payload.result
			}
		case (organizationConstructionMaterialPriceChangeConstants.CLEAR):
			return {
				...state,
				error         : null,
				isSending     : false,
				paged         : {},
				changed       : null,
				organizations : []
			}
		default:
			return state
	}
}